import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BoosterApplicationComponent} from './booster-application/booster-application.component';
import {PublicSharedModule} from '../../shared/public-shared.module';

const routes: Routes = [
  {path: '', component: BoosterApplicationComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes), PublicSharedModule],
  declarations: [BoosterApplicationComponent]
})
export class BoosterApplicationModule {
}
